/**
 * @created : 2021/3/23
 * @author  : 王冲
 * @desc    : 团队列表/新建或加入团队/团队搜索 store
 */

import { observable, action, runInAction, toJS } from 'mobx';

import * as API from '../../../../api/getListData';
import * as qysAPI from '../../../../api/qysCheck';
import { clearTeamsCookie, emLogout, getQueryString } from '../../../../utils';
import { getLabel } from "@weapp/utils";
import { Dialog } from "@weapp/ui";
import mainStore from '../../../../components/main/store';
import { layoutPublicUrl, publicUrlapi } from '../../../../constants';
import { LayoutSDK } from "../../../../lib";


const { message } = Dialog;

export class HeaderTeanetStore {

    tenantTip = getLabel('62284', '在此您可以切换组织，还可以创建或加入组织')
    @observable tenantList: any = [];
    @observable loaded: boolean = false;
    qysTimer: any = null;

    // @action
    // init = () => {
    //     this.getTenantList();
    // }
    // 团队列表
    getTenantList = () => {
        API.getsiblingstenant().then((data: any) => {
            runInAction(() => {
                if (data.data) {
                    this.tenantList = data.data;
                }
                this.loaded = true;
                LayoutSDK.setDataByKey({
                    key: 'tenantListData',
                    value: toJS(this.tenantList),
                    source: 'layout'
                })
            });
        })
    }
    @action
    changeTeam = (tenant: any, isRoleChange?: boolean) => {//更改团队
        //契约锁校验
        this.checkQys(tenant, () => {
            //校验IP黑白名单
            this.checkIpEnable(tenant, () => {
                // 校验登录方式拦截
                this.checkLoginType(tenant, () => {
                    this.doChangeTeam(tenant, isRoleChange)
                })
            })
        })
    }

    /**
     *
     * @param params 轮询请求etoken判断登录状态
     */
    @action
    QysQrcodePolling = (params: any, callback: any) => {
        this.qysTimer = setInterval(() => {
            qysAPI.checkQysQrStatus(params).then((result: any) => {
                if (result?.data?.qysAccess) {
                    clearInterval(this.qysTimer);
                    callback && callback();
                }
            });
        }, 1000);
    }

    //切换团队-契约锁校验
    @action
    checkQys = (tenant: any, callback: Function) => {
        const { employeeId, tenantKey } = tenant;
        const qysParams = {
            targetEmployeeId: employeeId,
            targetTenantKey: tenantKey,
            operateType: 'pcChangeTenant'
        }
        qysAPI.checkQys(qysParams).then((result: any) => {
            if (result.data && typeof result.data === 'object' && result.data.qysCheckAuthUrl) {
                mainStore.changeQysCheckAuthUrl(result.data.qysCheckAuthUrl);
                mainStore.changeQysDialogShown(true);
                //契约锁校验
                this.QysQrcodePolling({
                    tenantKey: result.data?.tenantKey,
                    qysCheckAuthId: result.data?.qysCheckAuthId,
                    operateType: 'pcChangeTenant'
                }, () => callback())
            } else {
                callback()
            }
        })
    }

    //切换团队校验IP黑白名单
    @action
    checkIpEnable = (tenant: any, callback: Function) => {
        const { employeeId } = tenant;
        // 校验IP黑白名单
        API.changeTenantPermission({ employeeId }).then((data: any) => {
            runInAction(() => {
                if (data && data.actionMsgFlag == 'true') {
                    message({
                        type: "error",
                        content: data.message,
                    });
                    return;
                }
                callback(data);
            });
        });
    }

    //切换团队校验登录方式
    @action
    checkLoginType = (tenant: any, callback: Function) => {
        const { employeeId } = tenant;
        API.checkChangeTenantLoginType({ empId: employeeId, loginType: 'pc_account' }).then((res: any) => {
            runInAction(() => {
                if (res && res.code == -1) {
                    message({
                        type: "error",
                        content: res.message,
                    });
                    return;
                }
                callback();
            });
        });
    }

    //切换团队-检测跨系统单点信息
    @action
    doChangeTeam = (tenant: any, isRoleChange?: boolean) => {
        const { employeeId, tenantKey } = tenant;

        let sysLoginRedirectPath = window.TEAMS?.loginAccountInfo?.sysLoginRedirectPath || localStorage.getItem("LAYOUT_SYS_LOGIN_REDIRECT_PATH") || "";

        let sysEntrance = '';

        if (window.ecode_layoutGetChangeTenantEntrance){
            sysEntrance = window.ecode_layoutGetChangeTenantEntrance({tenant,isRoleChange}) || '';
        }

        API.ssoCheck({
            targetEmployeeId: employeeId,
            targetTenantKey: tenantKey,
            eteamsid: window.ETEAMSID
        }).then((res: any) => {
            this.clearEnvCookies();
            window.forbidReloginDialog = true;
            const onlineParams = {
                "userId": window.TEAMS?.currentUser?.userId,
                "eteamsId": window.ETEAMSID,
                "label": 'change_team',
                "channelId": window['E10_WS_channelId'] || null
            }
            API.basicOnlineExitConn(onlineParams).then(() => {
                // 跨系统单点
                if (res?.data?.changeInfo) {
                    window.location.href = `${res.data.targetDomain}/papi/passport/changeTenant/ssoChange?service=${encodeURIComponent(res.data.targetDomain)}&changeInfo=${encodeURIComponent(res.data.changeInfo)}`
                } else {
                    window.location.href = `${window.weappTenantEnv?.passportUrl || window.TEAMS?.passportUrl}${publicUrlapi}/papi/passport/changeTenantNew/${employeeId}?service=${encodeURIComponent(window.location.origin + (sysLoginRedirectPath || layoutPublicUrl) + sysEntrance)}&ETEAMSID=${window.ETEAMSID}`
                }
            }).catch(() => {
                if (res?.data?.changeInfo) {
                    window.location.href = `${res.data.targetDomain}/papi/passport/changeTenant/ssoChange?service=${encodeURIComponent(res.data.targetDomain)}&changeInfo=${encodeURIComponent(res.data.changeInfo)}`
                } else {
                    window.location.href = `${window.weappTenantEnv?.passportUrl || window.TEAMS?.passportUrl}${publicUrlapi}/papi/passport/changeTenantNew/${employeeId}?service=${encodeURIComponent(window.location.origin + (sysLoginRedirectPath || layoutPublicUrl) + sysEntrance)}&ETEAMSID=${window.ETEAMSID}`
                }
            })

        }).catch((error) => {
            console.log(error)
        })
    }

    @action
    clearEnvCookies = () => {
        clearTeamsCookie();
        emLogout();
        localStorage.removeItem('WEAPP_LAYOUT_DOC_DETAILSPOP');
        sessionStorage.setItem('enableTrans', "0");   //初始化翻译模式
    }
}

const instance = new HeaderTeanetStore();

export default instance;
